import {
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
  FormGroup,
  FormArray
} from "@angular/forms";

/** Validator to ensure holidays are on unique days of the year */
export function uniqueDateValidatorForMonths(): ValidatorFn {
  // eslint-disable-next-line no-null/no-null
  return (control: AbstractControl): ValidationErrors | null => {
    const monthControl = control;
    const dateControl = control.parent ? (control.parent as FormGroup).controls.d : undefined;
    const parent = control.parent ? control.parent.parent : undefined;
    if (parent instanceof FormArray) {
      const dayVals = parent.controls.filter(
        sibling =>
          monthControl &&
          dateControl &&
          sibling.value.m === monthControl.value &&
          sibling.value.d === dateControl.value
      );
      // eslint-disable-next-line no-null/no-null
      return dayVals.length > 1 ? { uniqueDateError: true } : null;
    }
    // eslint-disable-next-line no-null/no-null
    return null;
  };
}

export function uniqueDateValidatorForDays(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const monthControl = control.parent ? (control.parent as FormGroup).controls.m : undefined;
    return monthControl && monthControl.hasError("uniqueDateError")
      ? { uniqueDateError: true }
      : // eslint-disable-next-line no-null/no-null
        null;
  };
}

/** Validator to ensure holidays have unique name/labels */
export function uniqueNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const label = control.value;
    if (label) {
      const parent = control.parent ? control.parent.parent : undefined;
      if (parent instanceof FormArray) {
        const labels = parent.controls
          .map(sibling => {
            if (sibling instanceof FormGroup) {
              if (sibling.value.label) return sibling.value.label;
            }
          })
          .filter(val => val === label);
        // eslint-disable-next-line no-null/no-null
        return labels.length > 1 ? { uniqueNameError: true } : null;
      }
    }
    // eslint-disable-next-line no-null/no-null
    return null;
  };
}
